import $ from 'jquery';

var display_height = $(window).height();
var scrollTop = $(document).scrollTop();
var linea_elements = $('.linea-verticale');
linea_elements.append( '<div class="linea-verticale-inner"></div>' );
var new_array = new Array();

$(window).load(function() {
    linea_elements.each(function( index ) {
        new_array[index] = {};
        new_array[index]['linea_index'] = index; // index della linea nell'array delle linee
        new_array[index]['linea_height'] = $( this ).height(); // altezza della linea
        new_array[index]['linea_height_negative'] = 0 - $( this ).height(); // altezza della linea al negativo
        new_array[index]['linea_top'] = $( this ).offset().top + 32; // altezza della linea dalla cima della pagina
        new_array[index]['linea_element'] = $( this ).children(); // elemento child della linea (elemento che si muove)
        new_array[index]['linea_fix'] = $( this ).attr( 'data-fix' ); // attributo data-fix ad elem linea-verticale per sistemare altezza dal fondo pagina alla quale parte l'effetto
        if(new_array[index]['linea_fix'] == undefined) { new_array[index]['linea_fix'] = 0; }
        else { new_array[index]['linea_fix'] = parseInt(new_array[index]['linea_fix']); }
    });
});

if ( linea_elements.length > 0 ) {

    $(window).scroll(function(){ 
        scrollTop = $(document).scrollTop();
        for (let i = 0; i < new_array.length; i++) {
            var temp = scrollTop + display_height - new_array[i]['linea_top'] - new_array[i]['linea_height'] - new_array[i]['linea_fix'];
            var temp2 = 0;

            if( temp > 0 ) { temp2 = 0; }
            else if( temp < new_array[i]['linea_height_negative'] ) { temp2 = new_array[i]['linea_height_negative']; }
            else { temp2 = temp; }

            new_array[i]['linea_element'].css( 'top', temp2+'px' );
        }
    });
}

$(".green-box").each(function( index ) {
    setTimeout(() => { $(this).css({ marginBottom: '-' + ($(this)[0].clientHeight / 2) + 'px' }); }, 100);
});

$( window ).on( "resize", function() {
  $(".green-box").each(function( index ) {
    $(this).css({ marginBottom: '-' + ($(this)[0].clientHeight / 2) + 'px' });
  });
});


// WEBPACK FOOTER //
// ../views/blocks/tre-blocchi/tre-blocchi.js